module.exports = __webpack_public_path__ + "img/A006.89cfa347.svg";